import { render, staticRenderFns } from "./HandleError.vue?vue&type=template&id=447cd470&scoped=true"
import script from "./HandleError.vue?vue&type=script&lang=ts&setup=true"
export * from "./HandleError.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./HandleError.vue?vue&type=style&index=0&id=447cd470&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447cd470",
  null
  
)

export default component.exports